import React, { useState } from 'react'
import PropTypes from 'prop-types'
import StyledSwitch from './Switch-styles'

const Switch = ({ id, checked, onChange }) => {
  const [inputID] = useState(id || Math.random().toString())

  return (
    <StyledSwitch className="onoffswitch">
      <input
        type="checkbox"
        name="onoffswitch"
        className="onoffswitch-checkbox"
        id={inputID}
        tabIndex="0"
        checked={checked}
        onChange={onChange}
      />
      <label className="onoffswitch-label" htmlFor={inputID}>
        <span className="onoffswitch-inner" />
        <span className="onoffswitch-switch" />
      </label>
    </StyledSwitch>
  )
}

Switch.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Switch
